import { CONTAINER_STORAGE_FIELD_KEY_LIST } from '../../capabilities/container-storage';
import { ENV_VARS_FIELD_KEY_LIST } from '../../capabilities/env-vars/fieldKeys';
import { MAAS_COMMAND_ARGS_NORMAL_FIELD_KEY_LIST } from '../../capabilities/maas-command-args-normal/fieldKeys';
import { MAAS_NODE_GROUPS_FIELD_KEY_LIST } from '../../capabilities/maas-node-groups/fieldKeys';
import { MAAS_SYSTEM_CONFIG_FIELD_KEY_LIST } from '../../capabilities/maas-system-config/fieldKeys';

/** 训练集群 SKU 表单逻辑字段。 */
export const TC_FIELD_KEYS = [
  ...MAAS_SYSTEM_CONFIG_FIELD_KEY_LIST,
  ...ENV_VARS_FIELD_KEY_LIST,
  ...MAAS_NODE_GROUPS_FIELD_KEY_LIST,
  ...CONTAINER_STORAGE_FIELD_KEY_LIST,
  ...MAAS_COMMAND_ARGS_NORMAL_FIELD_KEY_LIST,
  'trainingCluster.runtime.type',
  'trainingCluster.network.nics',
  'trainingCluster.network.nicPricing',
] as const;

/** 训练集群 SKU 表单逻辑字段类型。 */
export type TcFieldKey = (typeof TC_FIELD_KEYS)[number];
